import { useCallback } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import { fetchCurrentAppCycle, selectApplicationCycle } from '.'

export const useAppCycle = () => useSelector(selectApplicationCycle)
export const useRelevantCycle = () => {
  const currentAppCycle = useAppCycle()

  return currentAppCycle
}
export const useFetchCurrentAppCycle = () => {
  const dispatch = useDispatch()
  return useCallback(() => dispatch(fetchCurrentAppCycle()), [dispatch])
}
